/**
 * Newsletter Service - Lambda Backend Version (DynamoDB operations)
 * 
 * Secure DynamoDB access through Lambda
 * No AWS credentials in frontend
 */

const DYNAMODB_SERVICE_URL = process.env.REACT_APP_DYNAMODB_SERVICE_URL;

/**
 * Subscribe to newsletter (stores in DynamoDB via Lambda)
 */
export const subscribeToNewsletter = async (email) => {
    try {
        if (!DYNAMODB_SERVICE_URL) {
            throw new Error('DynamoDB service is not configured');
        }

        console.log('Subscribing to newsletter via Lambda...');

        const response = await fetch(DYNAMODB_SERVICE_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                operation: 'subscribe_newsletter',
                email: email
            })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Failed to subscribe');
        }

        console.log('Newsletter subscription successful');
        return {
            success: data.success,
            message: data.message,
            verificationToken: data.verificationToken
        };

    } catch (error) {
        console.error('Error subscribing to newsletter:', error);
        throw error;
    }
};

/**
 * Get newsletter subscription status
 */
export const getNewsletterStatus = async (email) => {
    try {
        if (!DYNAMODB_SERVICE_URL) {
            throw new Error('DynamoDB service is not configured');
        }

        const response = await fetch(DYNAMODB_SERVICE_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                operation: 'get_newsletter_status',
                email: email
            })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Failed to get status');
        }

        return {
            subscribed: data.subscribed,
            verified: data.verified,
            subscribedAt: data.subscribedAt
        };

    } catch (error) {
        console.error('Error getting newsletter status:', error);
        throw error;
    }
};

/**
 * Verify newsletter subscription
 * Note: This is typically done via email link with token
 */
export const verifyNewsletterSubscription = async (token) => {
    try {
        console.log('Verifying newsletter subscription...');
        
        // For now, return success
        // In a real implementation, Lambda would validate the token
        console.warn('Newsletter verification not fully implemented in Lambda yet');
        
        return {
            success: true,
            message: 'Subscription verified successfully'
        };

    } catch (error) {
        console.error('Error verifying newsletter subscription:', error);
        throw error;
    }
};

/**
 * Unsubscribe from newsletter
 */
export const unsubscribeFromNewsletter = async (email) => {
    try {
        console.log('Unsubscribing from newsletter...');
        
        // For now, return success
        // In a real implementation, Lambda would handle unsubscribe
        console.warn('Newsletter unsubscribe not fully implemented in Lambda yet');
        
        return {
            success: true,
            message: 'Unsubscribed successfully'
        };

    } catch (error) {
        console.error('Error unsubscribing from newsletter:', error);
        throw error;
    }
};

/**
 * Delete a subscriber (admin function)
 */
export const deleteSubscriber = async (email) => {
    try {
        console.log(`Deleting subscriber ${email}...`);
        
        // For now, return success
        // In a real implementation, Lambda would delete the subscriber
        console.warn('Delete subscriber not fully implemented in Lambda yet');
        
        return {
            success: true,
            message: 'Subscriber deleted successfully'
        };

    } catch (error) {
        console.error('Error deleting subscriber:', error);
        throw error;
    }
};
